import styled from 'styled-components'

const options = [
  { label: 'pull', css: 'right' },
  { label: 'push', css: 'left' },
  { label: 'offset', css: 'margin-left' },
]

const renderFloatLeft = (size: string) => {
  let render = ''
  for (let i = 1; i <= 12; i++) {
    render += `& .col-${size}-${i}${i !== 12 && ', '}`
  }
  render += '{ float: left; }'
  return render
}

const renderWidth = (size: string) => {
  let render = ''
  // render 'col-xs-1'
  for (let i = 1; i <= 12; i++) {
    render += `& .col-${size}-${i} { width: ${(100 * i) / 12}% }`
  }
  // render 'col-xs-push-1'
  options.forEach((option) => {
    for (let i = 12; i >= 0; i--) {
      render += `& .col-${size}-${option.label}-${i} { ${option.css}: ${i !== 0 ? 100 / i : 'auto'}% }`
    }
  })
  return render
}

export const BootstrapGrid = styled.div`
  & .container {
    padding-right: 1em;
    padding-left: 1em;
    margin-right: auto;
    margin-left: auto;
  }
  @media (min-width: 768px) {
    & .container {
      width: 750px;
    }
  }
  @media (min-width: 992px) {
    & .container {
      width: 970px;
    }
  }
  @media (min-width: 1200px) {
    & .container {
      width: 1170px;
    }
  }
  & .container-fluid {
    padding-right: 1em;
    padding-left: 1em;
    margin-right: auto;
    margin-left: auto;
  }
  & .row {
    margin-right: -1em;
    margin-left: -1em;
  }
  & .row:after,
  & .row:before,
  & .container:before,
  & .container:after,
  & .container-fluid:before,
  & .container-fluid:after {
    display: table;
    content: ' ';
  }
  & .row:after,
  & .container:after,
  & .container-fluid:after {
    clear: both;
  }
  & .col-xs-1,
  & .col-sm-1,
  & .col-md-1,
  & .col-lg-1,
  & .col-xs-2,
  & .col-sm-2,
  & .col-md-2,
  & .col-lg-2,
  & .col-xs-3,
  & .col-sm-3,
  & .col-md-3,
  & .col-lg-3,
  & .col-xs-4,
  & .col-sm-4,
  & .col-md-4,
  & .col-lg-4,
  & .col-xs-5,
  & .col-sm-5,
  & .col-md-5,
  & .col-lg-5,
  & .col-xs-6,
  & .col-sm-6,
  & .col-md-6,
  & .col-lg-6,
  & .col-xs-7,
  & .col-sm-7,
  & .col-md-7,
  & .col-lg-7,
  & .col-xs-8,
  & .col-sm-8,
  & .col-md-8,
  & .col-lg-8,
  & .col-xs-9,
  & .col-sm-9,
  & .col-md-9,
  & .col-lg-9,
  & .col-xs-10,
  & .col-sm-10,
  & .col-md-10,
  & .col-lg-10,
  & .col-xs-11,
  & .col-sm-11,
  & .col-md-11,
  & .col-lg-11,
  & .col-xs-12,
  & .col-sm-12,
  & .col-md-12,
  & .col-lg-12 {
    position: relative;
    min-height: 1px;
    padding-right: 1em;
    padding-left: 1em;
  }

  /* XS */
  ${renderFloatLeft('xs')}
  ${renderWidth('xs')}

  @media (min-width: 768px) {
    ${renderFloatLeft('sm')}
    ${renderWidth('sm')}
  }
  @media (min-width: 992px) {
    ${renderFloatLeft('md')}
    ${renderWidth('md')}
  }
  @media (min-width: 1200px) {
    ${renderFloatLeft('lg')}
    ${renderWidth('lg')}
  }
`
